import { css } from 'styled-components';

// --fluix-px must stay a length: unit division (100vw / 1px) is unsupported on iOS 17 Safari and breaks every fpx().
export const fpx = (px: number) => `calc(${px} * var(--fluix-px))`;

interface IFluidScaleOptions {
  desktopWidth: number;
  desktopHeight: number;
  mobileWidth: number;
  mobileHeight: number;
}

// Portaled nodes (modals) sit outside the page root, so they need this mixin too.
export const fluidScale = ({
  desktopWidth,
  desktopHeight,
  mobileWidth,
  mobileHeight,
}: IFluidScaleOptions) => css`
  --fluix-px: min(calc(100vw / ${desktopWidth}), calc(100vh / ${desktopHeight}));

  @media (orientation: portrait) {
    --fluix-px: min(calc(100vw / ${mobileWidth}), calc(100vh / ${mobileHeight}));
  }
`;
